import { E164_PATTERN, MAX_ALLOWED_DESTINATIONS } from "@gioia365/contracts";

// I numeri ammessi di un'azienda (piano M4, D12 e Task 5): i telefoni che si possono chiamare, in E.164, al massimo dieci. Il
// Super admin di Gioia365 li scrive uno per riga (anche separati da virgola o punto e virgola): spazi, trattini, punti e
// parentesi dentro un numero si tolgono, un numero ripetuto vale una volta. Lo schema dei contratti, lo stesso del server,
// resta l'ultimo controllo; qui si dice quale numero non va. Gli stessi, al massimo venti, per i WhatsApp automatici (piano M6,
// R2, Task 7b; questione 414): `max`.

export type AllowedNumbers = { ok: true; numbers: string[] } | { ok: false; problem: "invalid"; number: string } | { ok: false; problem: "too_many" };

const SEPARATORS = /[\n\r,;]+/;
const INSIDE_A_NUMBER = /[\s().-]/g;

/** Un numero come lo scrive chi lo copia da una rubrica (spazi, trattini, punti, parentesi) senza quei segni. */
export function withoutSeparators(written: string): string {
  return written.replace(INSIDE_A_NUMBER, "");
}

/** I numeri scritti nel campo, in ordine, senza ripetizioni; vuoto se il campo è vuoto. */
export function parseAllowedNumbers(text: string, max: number = MAX_ALLOWED_DESTINATIONS): AllowedNumbers {
  const numbers: string[] = [];
  for (const piece of text.split(SEPARATORS)) {
    const written = piece.trim();
    if (written === "") continue;
    const number = withoutSeparators(written);
    if (!E164_PATTERN.test(number)) return { ok: false, problem: "invalid", number: written };
    if (!numbers.includes(number)) numbers.push(number);
  }
  if (numbers.length > max) return { ok: false, problem: "too_many" };
  return { ok: true, numbers };
}

/**
 * I numeri italiani che sembrano un fisso scritto senza lo 0: in Italia dopo +39 un fisso comincia con 0 e un cellulare con 3
 * (prova del 5 ottobre 2026, un numero ammesso scritto male). Soltanto un avviso: il numero si salva lo stesso.
 */
export function italianLandlinesWithoutZero(numbers: readonly string[]): string[] {
  return numbers.filter((number) => /^\+39[^03]/.test(number));
}
